import { useState } from 'react';
const slots = [5, 10, 15, 30, 45, 60, 90, 120];
const useTimeSlotsForSlider = function () {
  let appendMinutesAfter60 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const [timeSlots, setTimeSlots] = useState();
  if (!timeSlots) {
    const showMinuteAfterValue = appendMinutesAfter60 ? 60 : 45;
    const value = slots.map(x => x === 10 ? {
      label: "",
      value: x
    } : {
      label: x > showMinuteAfterValue ? "".concat(x, "m") : "".concat(x),
      value: x
    });
    setTimeSlots(value);
  }
  return timeSlots;
};
export { useTimeSlotsForSlider };